
















































import Vue from 'vue'
import { withDefault } from '@/components/exercises/measure/filters'
import { AUTO_REFRESH_PATIENTS, PATIENT_NOUN, SHOW_LOCATION_BY_VIBE } from '@/constants/app-variables'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as PatientActionNames } from '@/store/modules/patient/keys'
import { COMMON_ICONS_BASE64, convertBase64ForSrc } from '@/utils/image-utils'
import { AppGetterNames } from '@/store/modules/app/keys'

import { ONE_DAY } from '@/utils/time'
import {
  calcTotalEmrCost,
  calcOneTimeVitalSignGatewayRevenue,
  getOneTimeVitalsGatewayCost,
  calcMonthlyRevenueTotal,
} from '@/constants/site-stats'
import { toCurrency } from '@/store/utils/converter'
import moment from 'moment-timezone'
import { AGT_DEBUG } from '@/utils/constants'

export default Vue.extend({
  filters: { withDefault },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    siteStats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      refreshTime: 30 * 1000, // for temporary location info
      isStoppedRefreshing: false,
      isFetchingData: false,
      headers: [
        {
          text: 'Home',
          sortable: true,
          value: 'siteName',
          width: '60%',
        },
        {
          text: '# of GWs',
          sortable: true,
          value: 'gateways',
          width: 40,
        },
        {
          text: 'GW Revenue (one time)',
          sortable: true,
          value: 'oneTimeGatewayRevenue',
          width: 100,
        },
        {
          text: 'Monthly Revenue',
          sortable: true,
          value: 'monthlyRevenue',
          width: 100,
        },
        {
          text: 'One-time Cost',
          sortable: true,
          value: 'oneTimeCost',
          width: 100,
        },
        {
          text: 'Monthly Cost',
          sortable: true,
          value: 'monthlyCost',
          width: 100,
        },
        {
          text: 'Profit',
          sortable: true,
          value: 'profit',
          width: 100,
        },
      ].filter(it => !!it),
      statusColorMap: {
        active: this.$vuetify.theme.themes.light.green,
        completed: this.$vuetify.theme.themes.light.lavender,
      },
      statusLabelMap: {
        active: 'IN PROGRESS',
        completed: 'COMPLETED',
      },
      page: 1,
      pageCount: 1,
      sortBy: ['siteName'],
      sortDesc: [false],
    }
  },
  computed: {
    // ...mapGetters({
    //   siteStats: `${ModuleNames.siteStats}/${SiteStatsGetterNames.siteStatses}`,
    // }),
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isExecUser: AppGetterNames.isExecUser,
    }),
    convertedSitesForDataTable(): any[] {
      console.log(this.siteStats)
      return this.siteStats?.map(siteStats => ({
        siteId: siteStats.siteUsageStats.siteId,
        siteName: siteStats.siteName,
        glucometerReadings: siteStats.siteUsageStats.glucometerReadings,
        vitalSignAssignments: siteStats.siteUsageStats.vitalSignAssignments,
        gateways: siteStats.siteUsageStats.gateways,
        residents: siteStats.siteUsageStats.residents,
        avgUsagePerDay: this.roundTo1DecimalPlace(
          this.calcAvgUsagePerDay(
            siteStats.siteUsageStats.glucometerReadings,
            siteStats.siteUsageStats.queryStartTimestamp,
            siteStats.siteUsageStats.queryEndTimestamp
          )
        ),
        oneTimeGatewayRevenue: toCurrency(calcOneTimeVitalSignGatewayRevenue(siteStats.siteUsageStats)),
        monthlyRevenue: toCurrency(calcMonthlyRevenueTotal(siteStats.siteUsageStats)),
        oneTimeCost: toCurrency(getOneTimeVitalsGatewayCost(siteStats.siteUsageStats)),
        monthlyCost: toCurrency(calcTotalEmrCost(siteStats.siteUsageStats)),
        profit: toCurrency(
          calcOneTimeVitalSignGatewayRevenue(siteStats.siteUsageStats) +
            calcMonthlyRevenueTotal(siteStats.siteUsageStats) +
            -getOneTimeVitalsGatewayCost(siteStats.siteUsageStats) +
            -calcTotalEmrCost(siteStats.siteUsageStats)
        ),
        actions: [
          // {
          //   label: 'EDIT PROFILE',
          //   color: 'primary',
          //   onClick: this.onClickEditProfile(patient.id),
          // },
          // {
          //   label: 'RETURN PACKAGE',
          //   color: 'red',
          //   onClick: this.onClickRemovePackage(patient.id),
          // },
        ],
      }))
    },
    iconImage(): string {
      return convertBase64ForSrc(COMMON_ICONS_BASE64.INFO_CIRCLE)
    },
    showLoading(): Boolean {
      //combines loading states from props and data
      return this.loading || this.isFetchingData
    },
  },
  async mounted() {
    //await this[PatientActionNames.getPatients]()
    this.resumeRefreshing()
  },
  beforeDestroy(): void {
    this.stopRefreshing()
  },
  methods: {
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    // ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    async fetchData() {
      this.isFetchingData = true
      console.log('fetchData()!')
      // await this[SiteStatsActionNames.getSiteStatses]()
      this.isFetchingData = false
    },
    stopRefreshing() {
      this.isStoppedRefreshing = true
    },
    resumeRefreshing() {
      this.isStoppedRefreshing = false
      this.startRefreshing()
    },
    startRefreshing() {
      if (this.isStoppedRefreshing) return
      if (!AUTO_REFRESH_PATIENTS) return
      setTimeout(async () => {
        try {
          await this.fetchData()
        } catch (e) {
          console.log('error', e)
        }
        this.startRefreshing()
      }, this.refreshTime)
    },

    roundTo1DecimalPlace(value) {
      return Math.round(10 * value) / 10
    },
    toCurrency(value: number): string {
      return '$' + (Math.round(100 * value) / 100).toFixed(2)
    },

    calcAvgUsagePerDay(dataPoints, start, end): number {
      if (dataPoints === 0) {
        return 0
      }

      let days = Math.round((end - start) / ONE_DAY)

      if (days < 1 || days > 365 * 20) {
        return 0
      }
      return dataPoints / days //Math.round((10 * dataPoints) / days) / 10
    },
  },
})
